/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Irreversible_Warning_OrgInputs */



/**
* | output |
* | --- |
* | "Agents marked for it will delete data, merge changes or restart devices — in oneAI and in connected systems — without asking anyone. This cannot be undone." |
*
* @param {Agent_Irreversible_Warning_OrgInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_irreversible_warning_org = /** @type {((inputs?: Agent_Irreversible_Warning_OrgInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Irreversible_Warning_OrgInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dafür markierte Agenten löschen Daten, führen Änderungen zusammen oder starten Geräte neu — in oneAI und in verbundenen Systemen —, ohne jemanden zu fragen. Das lässt sich nicht rückgängig machen.")
	return /** @type {LocalizedString} */ ("Agents marked for it will delete data, merge changes or restart devices — in oneAI and in connected systems — without asking anyone. This cannot be undone.")
});